import { buildColorPropsSDKFactoryCreator } from './colorPropsSDKFactoryBuilder';
export const createIconColorPropsSDKFactory = buildColorPropsSDKFactoryCreator('iconColor');
//# sourceMappingURL=iconColorPropsSDKFactory.js.map